<div #filterBody class="filter__body" [class.opened]="isOpened">
  <div #filterContainer class="filter__body-wrapper">
    <div class="filter__body-head">
      <div class="title">
        <span [translate]="titleKey || 'filters.label.filter'"></span>
      </div>
      <div class="action">
        <btn [link]="true"
          (click)="resetFilter.emit()"
          [buttonText]="buttonKey || 'filters.btn.clear-all'"
        ></btn>
      </div>
    </div>

    <ng-content></ng-content>
  </div>
</div>
